export default "__VITE_ASSET__C0O2owXD__"